export function LoadingData() {
    return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <LoadingComponent />
    </div>;
}

export function LoadingComponent() {
    return <div>
        <h2>Please wait ⏳</h2>
        <p>Fetching the data from all over the galaxy ⏳</p>
        <img
            src="https://i.giphy.com/26n6WywJyh39n1pBu.webp"
            alt="Loading data GIF"
            style={{ width: '300px', height: '300px', margin: '20px' }}
        />
    </div>
}